export interface CatalogAttachment {
  id: number;
  url: string;
  title: string | null;
  mime_type: string | null;
}

export interface CatalogCustomTag {
  facet: string;
  label: string;
}

export interface CatalogResource {
  wpId: number;
  title: string;
  slug: string;
  url: string;
  status: string;
  wpCreatedAt: string | null;
  wpModifiedAt: string | null;
  hasResolution: boolean;
  contentType: string | null;
  audiences: string[];
  clinicalAreas: string[];
  topics: string[];
  customTags: CatalogCustomTag[];
  moveToWebsite: string | null;
  committedAt: string | null;
  attachments: CatalogAttachment[];
  underRevision: boolean | null;
}

export type CatalogFacetKey = 'contentType' | 'topic' | 'audience' | 'clinicalArea' | 'format';

export type CatalogFacets = Record<CatalogFacetKey, Record<string, number>>;

export interface CatalogListMeta {
  total: number;
  page: number;
  perPage: number;
  syncedAt: string | null;
  cached: boolean;
  cacheExpiry: string;
  facets: CatalogFacets;
}

export interface CatalogListResponse {
  success: true;
  data: CatalogResource[];
  meta: CatalogListMeta;
}

export const CATALOG_FACET_KEYS: CatalogFacetKey[] = [
  'contentType',
  'topic',
  'audience',
  'clinicalArea',
  'format',
];

export const EMPTY_CATALOG_FACETS: CatalogFacets = {
  contentType: {},
  topic: {},
  audience: {},
  clinicalArea: {},
  format: {},
};
